import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { COURSE, COURSE_ALL, COURSE_CREATE, COURSE_LIST, GLOBAL_STATE } from '../constants/actionTypes'

const courseCreatesGlobalSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const courseSelector = createSelector(courseCreatesGlobalSelector, data => data[COURSE])

export const courseAllSelector = createSelector(courseCreatesGlobalSelector, data => data[COURSE_ALL])

export const courseListSelector = createSelector(courseCreatesGlobalSelector, data => data[COURSE_LIST])

export const courseCreateSelector = createSelector(courseCreatesGlobalSelector, data => data[COURSE_CREATE])

export const courseAllOptionsSelector = createSelector(courseAllSelector, courseAll => {
  return {
    loading: courseAll.loading,
    error: courseAll.error,
    options: Array.isArray(courseAll.data)
      ? courseAll.data.map(item => ({ label: item.title || '', value: item.id }))
      : [],
  }
})
